var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7055 17.4479C13.5471 17.4479 13.3888 17.3896 13.2638 17.2646L7.83047 11.8313C6.94714 10.9479 6.94714 9.49792 7.83047 8.61458L13.2638 3.18125C13.5055 2.93958 13.9055 2.93958 14.1471 3.18125C14.3888 3.42292 14.3888 3.82292 14.1471 4.06458L8.7138 9.49792C8.3138 9.89792 8.3138 10.5479 8.7138 10.9479L14.1471 16.3812C14.3888 16.6229 14.3888 17.0229 14.1471 17.2646C14.0221 17.3812 13.8638 17.4479 13.7055 17.4479Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.f54870ad5152229531105423e9985f82.svg";
export { ForwardRef as ReactComponent };